module.exports = __webpack_public_path__ + "img/POP-00008-3.bec4ac71.png";